export default __webpack_public_path__ + "static/media/pgcadd.d1838a5c.png";